module.exports = __webpack_public_path__ + "img/cooperate_qy_08@2x.a5ba96a5.png";